import axios from 'axios';

import authService from 'src/services/authService';
import configurationService from 'src/services/configurationService';
import { environments } from 'src/siteConfig';

import { logError } from '../logError';

const NO_EVENT_TYPE_ERROR = 'No eventType passed to captureEvent';

const getToken = (): Promise<string | void | null> => {
  if (configurationService.getEnvironment() === environments.development) {
    // this is a bit painful, but cypress fails on the getToken step. For local development it uses the mock endpoint.
    return Promise.resolve('some.bogus.jwt');
  }
  return authService.getToken();
};

const captureEvent = async ({
  eventType,
  data,
}: {
  eventType: string;
  data: any;
}) => {
  if (!eventType) {
    throw new Error(NO_EVENT_TYPE_ERROR);
  }
  const params = {
    timestamp: new Date().toISOString(),
    eventType,
    data,
  };

  const token = await getToken();
  if (!token) {
    return;
  }

  const url = configurationService.getEventCaptureApiUrl();
  try {
    await axios.post(url, params, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error: any) {
    logError({ errorCode: 'EVENT_CAPTURE_API_ERROR' }, { error });
  }
};

export default captureEvent;
